import { exchangeLaunch_site, userKey } from "../App";

export const useSportsExchange = () => {

    const exchangeLaunchFunction = (exchangeState = 1) => {
        const mainDiv = document.getElementById("main");
        const getHeight = mainDiv.scrollHeight;
        const getWidth = mainDiv.clientWidth;
        // console.log(getHeight, getWidth, mainDiv);
        let fullUrl = `${exchangeLaunch_site}?tfkhgjfecb646c6c2b7fe0fae3fb183d0036d25ba7f50eslkgdhjloken=${(JSON.parse(localStorage.getItem(userKey))?.value)}&excnbvcbnm3m6bm35b45n3m45bnhanged=${exchangeState}`;

        const exchangeWindow = window.open(`${fullUrl}`, `<div id="exchangeLaunch"></div>`, `width=${getWidth},height=${getHeight}`);
        window.onload = () => {
            exchangeWindow.opener.document.getElementById("exchangeLaunch").innerHTML = `<div id=""></div>`;
        }

        // // Open the URL in a new tab
        // const exchangeTab = window.open(fullUrl, '_blank');

        // // Optionally, set the size of the new tab to match the size of the mainDiv
        // exchangeTab.onload = () => {
        //     exchangeTab.resizeTo(getWidth, getHeight);
        // }
    }

    return {
        exchangeLaunchFunction,
    };
};